import * as React from 'react';
const filter = require('lodash.filter');

import {
  CommercialPromoBlocks,
} from '../../components/commercial_promo_blocks/commercial_promo_blocks';
import { IMainPage } from '../../models/mainpage';
import { IPromo } from '../../models/promo';
import { ISeoBlockItem } from '../../models/seo_urls';

import { connect } from 'react-redux';

interface IProps {
  promo: IPromo[];
  seoUrlsBlocks: ISeoBlockItem[];
  isFetching: boolean;
}

class CommercialPromo extends React.Component<IProps> {

  public getPromoBlocks(): IPromo[] {
    return filter(this.props.promo, { type: 'group' });
  }

  public getPromoBanner(): IPromo[] | undefined {
    return filter(this.props.promo, { type: 'special' });
  }

  public render() {
    return (
      <CommercialPromoBlocks
        promoBlocks={this.getPromoBlocks()}
        promoSpecial={this.getPromoBanner()}
        promoMenu={this.props.seoUrlsBlocks}
        />
    );
  }
}

const CommercialPromoWrapper = connect((state: { mainpage: IMainPage }) => ({
  promo: state.mainpage.promoBlocks,
  seoUrlsBlocks: state.mainpage.seoUrlsBlocks,
  isFetching: state.mainpage.isFetching,
}))(CommercialPromo);

export {
  CommercialPromoWrapper as CommercialPromo,
  CommercialPromo as ComercialPromoClass
};
